import React, { useState, useEffect } from 'react';
import { getCurrentUser } from 'aws-amplify/auth';
import DashboardWithAPI from '../components/DashboardWithAPI';
import './Dashboard.css';

export const Dashboard: React.FC = () => {
  const [user, setUser] = useState<any>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    loadUser();
  }, []);

  const loadUser = async () => {
    try {
      const currentUser = await getCurrentUser();

      // Get email from JWT token claims (works for both Google OAuth and email/password)
      const { fetchAuthSession } = await import('aws-amplify/auth');
      const session = await fetchAuthSession();
      const email = session.tokens?.idToken?.payload?.email as string;

      // Map Cognito user to expected format
      setUser({
        name: email || currentUser.username || 'User',
        email: email || currentUser.signInDetails?.loginId || currentUser.username || '',
        avatar_url: undefined,
        plan: 'workflow' // Default plan, should come from API/DynamoDB
      });
    } catch (error) {
      console.error('Failed to load user:', error);
      // Fallback user for development
      setUser({
        name: 'User',
        email: 'user@photosynthesize.app',
        plan: 'workflow'
      });
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <div className="flex items-center justify-center h-screen">
        <div className="w-8 h-8 border-4 border-primary-400 border-t-transparent rounded-full animate-spin" />
      </div>
    );
  }

  return <DashboardWithAPI user={user} />;
};

export default Dashboard;
